import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VerifyComponent } from './verify/verify.component';
import { SignupComponent } from './signup/signup.component';
import { LoginComponent } from './login/login.component';
import { AuthComponent } from './auth.component';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CountriesPageModule } from '../countries/countries.module';
import { PrivacyPolicyModule } from '../_shared/components/privacy-policy/privacy-policy.module';
import { TermsAndConditionsModule } from '../_shared/components/terms-and-conditions/terms-and-conditions.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaModule } from "ng-recaptcha";
import { environment } from '../../environments/environment';
import { LoginSignupHomeComponent } from './login-signup-home/login-signup-home.component';
import { AuthPrivateComponent } from '../auth-private/auth-private.component';
import { UpdateNameComponent } from './update-name/update-name.component';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: '',
        component: AuthComponent
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        CountriesPageModule,
        RouterModule.forChild(routes),
        PrivacyPolicyModule,
        TermsAndConditionsModule,
        RecaptchaModule,
        ForgotPasswordComponent,
        LoginSignupHomeComponent,
        AuthPrivateComponent,
        LoginComponent,
        SignupComponent,
        VerifyComponent,
        TranslateModule.forChild()
    ],
    declarations: [
        AuthComponent,
        UpdateNameComponent 
    ],
    exports: [AuthComponent],
    providers: [
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.RECAPTCHA_SITE_KEY }
    ],

})
export class AuthModule { }
